export default "__VITE_ASSET__LAU6ruqs__"